// Styles
import '../../../../src/assets/stylus/ui/component/_jOverlay.scss'
import { h } from 'vue'  // h 함수

/* @vue/component */
export default {
  name: 'j-overlay',
  props: {
    absolute: Boolean,
    contentRight: Boolean,
    color: { type: String, default: '#212121' },
    dark: { type: Boolean, default: true },
    opacity: { type: [Number, String], default: 0.32},
    modelValue: { type : Boolean, default: false },
    zIndex: { type: [Number, String], default: 5 },
  },

  computed: {
    __scrim() {
      return h('div', {
        class: {
          'j-overlay__scrim': true,
        },
        style: {
          backgroundColor: this.color,
          opacity: this.computedOpacity,
        }
      })
    },
    classes() {
      return {
        'j-overlay': true,
        'j-overlay--absolute': this.absolute,
        'j-overlay--active': this.isActive,
        'j-overlay--content-right': this.contentRight,
      }
    },
    computedOpacity() {
      return Number(this.isActive ? this.opacity : 0)
    },
    isActive() {
      return this.modelValue
    },
    styles() {
      return {
        zIndex: this.zIndex,
      }
    },
  },

  methods: {
    genContent() {
      return h('div', {
        class: 'j-overlay__content',
      }, this.$slots.default())
    },
  },

  render() {
    const children = [this.__scrim]

    if(this.isActive) children.push(this.genContent())

    return h('div', {
      class: this.classes,
      style: this.styles,
      onClick: (e) => { this.$emit('click', e) }
    }, children)
  },
}
